import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
//import { ModalOptions } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-alert-model',
  templateUrl: './alert-model.component.html',
  styleUrls: ['./alert-model.component.css']
})
export class AlertModelComponent {
  title: string;
  message: string;
  data: any;

  constructor(
    public activeModal: NgbActiveModal
    //public inputData: ModalOptions
  ) {
    // Default values - will be overridden by utility service
    this.title = 'Confirm';
    this.message = 'Are you sure you want to delete?';
   }

  close(): void {
    this.activeModal.close(false);
  }

  confirm(): void {
    this.activeModal.close(true);
  }

}
